import { FC, useContext } from 'react';

import { Label, Tooltip } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './OnlineBookingNotEnableTooltip.module.scss';

export const OnlineBookingNotEnableTooltip: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <Tooltip
      content={t('host.online_booking.not_enabled')}
      position="bottom"
      contentClassName={s.tooltip}
    >
      <Label iconName="SmartGamerDashedIcon" color="gray-primary" />
    </Tooltip>
  );
};
